import { ReactNode } from 'react';

type Props = {
  maxCount: number;
  currentCount: number;
  color?: string;
  size?: number;
  strokeWidth?: number;
  children?: ReactNode;
};

const CircularProgress = ({
  maxCount,
  currentCount,
  color = '#111',
  size = 18,
  strokeWidth = 2.5,
  children,
}: Props) => {
  // A maxCount of 0 (unlimited/unprovisioned plan) would make the ratio NaN/Infinity
  // and render an invalid SVG strokeDashoffset; treat it as an empty (0%) ring.
  const percentage = maxCount > 0 ? Math.min(Math.round((currentCount / maxCount) * 100), 100) : 0;

  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <div
      className="relative flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} className="rotate-[-90deg] absolute">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          className="stroke-neutral-300"
          strokeWidth={strokeWidth}
          fill="none"
        />
      </svg>
      <svg width={size} height={size} className="rotate-[-90deg] absolute">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          style={{ stroke: color }}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          fill="none"
        />
      </svg>
      {children != null && (
        <div className="relative flex items-center justify-center">{children}</div>
      )}
    </div>
  );
};

export default CircularProgress;
